import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsZillowComponent } from './simple-icons-zillow.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsZillowComponent ],
    exports:      [ SimpleIconsZillowComponent ],
    bootstrap:    []
})
export class SimpleIconsZillowModule {}
